import React, { useState, useEffect } from 'react';
import { Button, Input, Select, Card, Row, Col } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { Option } = Select;

const RegexTransformList = ({ value = [], onChange }) => {
  console.log('RegexTransformList mounted, value:', value);
  
  const [transforms, setTransforms] = useState(value.length > 0 ? value : [
    { source_key: '', pattern: '', replacement: '', target_key: '', flags: [] }
  ]);

  useEffect(() => {
    console.log('RegexTransformList value changed:', value);
    if (value && value.length > 0) {
      setTransforms(value);
    }
  }, [value]);

  const handleChange = (index, field, fieldValue) => {
    console.log('handleChange:', index, field, fieldValue);
    const newTransforms = [...transforms];
    newTransforms[index] = { ...newTransforms[index], [field]: fieldValue };
    setTransforms(newTransforms);
    if (onChange) {
      console.log('Calling onChange with:', newTransforms);
      onChange(newTransforms);
    }
  };

  const addTransform = () => {
    const newTransforms = [...transforms, { source_key: '', pattern: '', replacement: '', target_key: '', flags: [] }];
    setTransforms(newTransforms);
    if (onChange) {
      onChange(newTransforms);
    }
  };

  const removeTransform = (index) => {
    const newTransforms = transforms.filter((_, i) => i !== index);
    setTransforms(newTransforms);
    if (onChange) {
      onChange(newTransforms);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      {transforms.map((transform, index) => (
        <Card 
          key={index}
          size="small"
          style={{ backgroundColor: '#f6ffed', border: '1px solid #b7eb8f' }}
          title={`Transform ${index + 1}`}
          extra={
            transforms.length > 1 && (
              <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => removeTransform(index)}
              />
            )
          }
        >
          <Row gutter={[8, 8]} align="middle">
            <Col span={3} style={{ textAlign: 'right', fontWeight: 500 }}>From</Col>
            <Col span={5}>
              <Input
                placeholder="checkout"
                value={transform.source_key}
                onChange={(e) => handleChange(index, 'source_key', e.target.value)}
                size="small"
              />
            </Col>

            <Col span={3} style={{ textAlign: 'right', fontWeight: 500 }}>Pattern</Col>
            <Col span={5}>
              <Input
                placeholder="^chk(.*)"
                value={transform.pattern}
                onChange={(e) => handleChange(index, 'pattern', e.target.value)}
                size="small"
              />
            </Col>

            <Col span={3} style={{ textAlign: 'right', fontWeight: 500 }}>Replace</Col>
            <Col span={5}>
              <Input
                placeholder="test$1"
                value={transform.replacement}
                onChange={(e) => handleChange(index, 'replacement', e.target.value)}
                size="small"
              />
            </Col>

            <Col span={3} style={{ textAlign: 'right', fontWeight: 500 }}>To</Col>
            <Col span={5}>
              <Input
                placeholder="checkout2"
                value={transform.target_key}
                onChange={(e) => handleChange(index, 'target_key', e.target.value)}
                size="small"
              />
            </Col>

            <Col span={3} style={{ textAlign: 'right', fontWeight: 500 }}>Flags</Col>
            <Col span={13}>
              <Select
                mode="multiple"
                placeholder="Optional flags"
                value={transform.flags || []}
                onChange={(v) => handleChange(index, 'flags', v)}
                style={{ width: '100%' }}
                size="small"
              >
                <Option value="IGNORECASE">IGNORECASE</Option>
                <Option value="MULTILINE">MULTILINE</Option>
                <Option value="DOTALL">DOTALL</Option>
              </Select>
            </Col>
          </Row>

          <div style={{ fontSize: '11px', color: '#666', marginTop: '8px' }}>
            Tips: Use capture groups () in pattern, reference with $1, $2 in replacement. Leave replacement empty to extract match.
          </div>
        </Card>
      ))}
      
      <Button
        type="dashed"
        onClick={addTransform}
        icon={<PlusOutlined />}
        style={{ width: '100%' }}
        size="small"
      >
        Add Transform
      </Button>
    </div>
  );
};

export default RegexTransformList;
